"use strict";
// runtime 通过该属性默认开启多语言，designer不开启
window.langController.enableWujiI18n = true;
